import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBaseService } from '../core/service-base.service';
import { Observable } from 'rxjs';

export interface SessionData {
  username: string;
  email: string;
  locale: string;
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(private http: HttpClient, private serviceBase: ServiceBaseService) {}

  login(username, password): Observable<{ token: string; user: {} }> {
    const authRequest = this.http.post<{ token: string; user: {} }>(
      this.serviceBase.getServiceBase() + '/session',
      { username: username, password: password }
    );
    return authRequest;
  }

  register(email, password, firstname, lastname, countryCode): Observable<any> {
    return this.http.post<any>(
      this.serviceBase.getServiceBase() + '/signup',
      { email, firstname, lastname, password, countryCode: countryCode, agree: true, locale: 'en'}
    );
  }

  requestPasswordReset(username: string, locale: string = 'en'): Observable<any> {
    return this.http.post<any>(
      this.serviceBase.getServiceBase() + '/pwreset',
      { username, locale }
    );
  }

  resetPassword(token: string, password: string): Observable<any> {
    return this.http.put<any>(
      this.serviceBase.getServiceBase() + '/pwreset',
      { token, password }
    );
  }

  getSession(): Observable<SessionData> {
    return this.http.get<SessionData>(
      this.serviceBase.getServiceBase() + '/session/',
      this.serviceBase.getHeaders()
    );
  }
}
